export const api = {
    generateMinutesEditorSections: (meetingId: string): string =>
        `/api/events/${meetingId}/minutes-sections/generate/`,
    minutesEditorSections: (meetingId: string, mode?: string): string =>
        `/api/events/${meetingId}/minutes-sections/${mode ? `?mode=${mode}` : ''}`,
    minutesEditorSectionsItem: (meetingId: string, sectionId: string): string =>
        `/api/events/${meetingId}/minutes-sections/${sectionId}/`,
    uploadMinutesSectionImage: () => '/api/images/minutes-sections/',
    downloadMinutesSectionImage: (imageId: string): string =>
        `/api/images/minutes-sections/${imageId}/download/`
};

export const admin = {
    openMinutes: (roomSlug: string, meetingId: string, hash: string): string =>
        `/administrator/rooms/${roomSlug}/meetings/${hash}/meeting/${meetingId}/minutes-editor/`,

    minutesEditorDocument: (
        roomSlug: string,
        meetingId: string,
        hash: string,
        documentId: string
    ): string =>
        `/administrator/rooms/${roomSlug}/meetings/${hash}/meeting/${meetingId}/minutes-editor/document/${documentId}/`,

    minutesEditorLink: (
        roomSlug: string,
        meetingId: string,
        hash: string,
        linkId: string
    ): string =>
        `/administrator/rooms/${roomSlug}/meetings/${hash}/meeting/${meetingId}/minutes-editor/link/${linkId}/`
};

export const attendee = {
    openMinutes: (roomSlug: string, meetingId: string): string =>
        `/rooms/${roomSlug}/meetings/${meetingId}/minutes-editor/`,

    minutesEditor: (roomSlug: string, meetingId: string): string =>
        `/rooms/${roomSlug}/meetings/${meetingId}/minutes-editor/`,

    minutesEditorDocument: (roomSlug: string, meetingId: string, documentId: string): string =>
        `/rooms/${roomSlug}/meetings/${meetingId}/minutes-editor/document/${documentId}/`,

    minutesEditorLink: (roomSlug: string, meetingId: string, linkId: string): string =>
        `/rooms/${roomSlug}/meetings/${meetingId}/minutes-editor/link/${linkId}/`
};
